import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const AttachmentViewedStreamHubEvents = lazyAfterPaint(
	() => import(/* webpackChunkName: "async-attachment-viewed-streamhub-events" */ './index'),
	{ ssr: false },
);

const AsyncAttachmentViewedStreamHubEvents = (): React.JSX.Element => (
	<ErrorBoundary
		id="async.jira.attachment-viewed-streamhub-events"
		packageName="jiraAttachmentViewedStreamHubEvents"
	>
		<Placeholder name="attachment-viewed-streamhub-events" fallback={null}>
			<AttachmentViewedStreamHubEvents />
		</Placeholder>
	</ErrorBoundary>
);

export default AsyncAttachmentViewedStreamHubEvents;
